import React from 'react';
import { Box, Slider, Typography, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.secondary.main,
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: theme.palette.secondary.main,
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
}));

export default function NumberSelector({ time, setValue, min = 3, max = 60 }) {
  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value === '' ? min : Number(event.target.value);
    if (newValue >= min && newValue <= max) {
      setValue(newValue);
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'streach', gap: 2 }}>
        <CustomSlider
            value={typeof time === 'number' ? time : min}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            valueLabelDisplay="auto"
            min={min}
            max={max}
            sx={{ flex: 1 }}
        />
        <TextField
            sx={{
                width: 80,
                '& .MuiInputBase-input': {
                    textAlign: 'center',
                }
            }}
            value={time}
            onChange={handleInputChange}
            size="small"
            disabled={true}
        />
    </Box>
  );
}